(function () {
  const STORE = (window.Shopify && Shopify.routes && Shopify.routes.root)
    ? window.location.origin + Shopify.routes.root.replace(/\/$/, '')
    : window.location.origin;

  const KEY = 'vendorByHandle:v4';
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}

  const pending = new Map();
  let ref = null; // metrics copied from a native brand label

  function handleOf(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Native brand label: a text span in the details block that isn't the title or a price
  function brandEl(card, titleText) {
    for (const el of card.querySelectorAll('.ais-hit--details span.builder-text')) {
      const t = el.textContent.trim();
      if (!t || t === titleText || t.startsWith('$')) continue;
      return el;
    }
    return null;
  }

  function vendorOf(handle) {
    if (saved[handle]) return Promise.resolve(saved[handle]);
    if (!pending.has(handle)) {
      pending.set(handle, fetch(STORE + '/products/' + handle + '.json')
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(d => {
          const v = d.product.vendor;
          if (v) {
            saved[handle] = v;
            try { sessionStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
          }
          return v;
        })
        .catch(err => { pending.delete(handle); throw err; }));
    }
    return pending.get(handle);
  }

  // Copy spacing and typography from the native brand label so both sit at the same height
  function captureRef(brand) {
    if (ref || !brand) return;
    const cs = getComputedStyle(brand);
    const block = brand.closest('.builder-block') || brand;
    const bcs = getComputedStyle(block);
    ref = {
      fontFamily: cs.fontFamily,
      fontSize: cs.fontSize,
      fontWeight: cs.fontWeight,
      letterSpacing: cs.letterSpacing,
      color: cs.color,
      lineHeight: cs.lineHeight,
      marginTop: bcs.marginTop,
      marginBottom: bcs.marginBottom,
      paddingTop: bcs.paddingTop,
      paddingBottom: bcs.paddingBottom,
      height: bcs.height
    };
  }

  function styleBadge(el) {
    const s = {
      display: 'block',
      textAlign: 'left',
      boxSizing: 'border-box'
    };
    if (ref) {
      Object.assign(s, {
        fontFamily: ref.fontFamily,
        fontSize: ref.fontSize,
        fontWeight: ref.fontWeight,
        letterSpacing: ref.letterSpacing,
        color: ref.color,
        lineHeight: ref.lineHeight,
        marginTop: ref.marginTop,
        marginBottom: ref.marginBottom,
        paddingTop: ref.paddingTop,
        paddingBottom: ref.paddingBottom,
        minHeight: ref.height
      });
    } else {
      Object.assign(s, { fontWeight: '700', fontSize: '16px', margin: '0 0 4px', minHeight: '1.3em' });
    }
    Object.assign(el.style, s);
  }

  function processCards() {
    for (const card of document.querySelectorAll('[data-slot="shopify:productBox"]')) {
      const title = card.querySelector('.ais-hit--subtitle');
      if (!title) continue; // empty clone

      const titleText = title.textContent.trim();
      const brand = brandEl(card, titleText);
      if (brand) { captureRef(brand); continue; } // native brand: no request

      let badge = card.querySelector('.vendor-badge');
      if (badge) { styleBadge(badge); continue; }

      const handle = handleOf(card);
      if (!handle) continue;

      badge = document.createElement('div');
      badge.className = 'vendor-badge';
      styleBadge(badge);
      title.before(badge); // space reserved immediately

      if (saved[handle]) { badge.textContent = saved[handle]; continue; }

      vendorOf(handle)
        .then(v => { if (v) badge.textContent = v; else badge.remove(); })
        .catch(err => { badge.remove(); console.error('[vendor] failed for', handle, err); });
    }
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; processCards(); });
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
